import styled, { css } from 'styled-components';
import { transparentize } from 'polished';
import { Link, NavLink } from 'react-router-dom';
import { BareButtonStyle } from '../../../core/components/styled';
import { fadeAndSlideInDown } from '../../../core/styles';
import { NavigationBarIcon } from './NavBar';
import { media } from '../../../utils/styles';

export const DesktopNavBarLogo = styled(NavLink)`
  width: 172px;
  height: 37px;
  background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjA2cHgiIGhlaWdodD0iNDNweCIgdmlld0JveD0iMCAwIDIwNiA0MyIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBza2V0Y2h0b29sIDUzLjIgKDcyNjQzKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT41RUU1N0I0Qi1FMUU5LTRBM0ItQkZDRi01NzdEOURFNTg2NDA8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIHNrZXRjaHRvb2wuPC9kZXNjPgogICAgPGcgaWQ9InBhcnRuZXItcG9ydGFsIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iMjItTWVudSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTYwLjAwMDAwMCwgLTUzLjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iTWVudSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0icnViaWNvbi1wYXJ0bmVyLXdoaXRlIj4KICAgICAgICAgICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2MC4wMDAwMDAsIDUzLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDcuMzU2MzIyLCA4LjcwMzI5NykiIGZpbGw9IiNGRkZGRkYiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTE3LjY0MDIyOTksNS42OTY3MDMzIEMxNy42NDAyMjk5LDEuMDY4MTMxODcgMTQuMDQ5MDQyMSwwLjQzNTE2NDgzNSAxMC41NzYyNDUyLDAuNDM1MTY0ODM1IEwwLjE5NzMxODAwOCwwLjQzNTE2NDgzNSBMMC4xOTczMTgwMDgsMTcuNzYyNjM3NCBMMy45MDY4OTY1NSwxNy43NjI2Mzc0IEwzLjkwNjg5NjU1LDExLjExNjQ4MzUgTDguODM5ODQ2NzQsMTEuMTE2NDgzNSBMMTMuNzMzMzMzMywxNy43NjI2Mzc0IEwxOC4zMTExMTExLDE3Ljc2MjYzNzQgTDEzLjEwMTkxNTcsMTAuODM5NTYwNCBDMTUuNDMwMjY4MiwxMC41NjI2Mzc0IDE3LjY0MDIyOTksOC45MDEwOTg5IDE3LjY0MDIyOTksNS42OTY3MDMzIFogTTMuOTA2ODk2NTUsMy41NjA0Mzk1NiBMMTAuMDYzMjE4NCwzLjU2MDQzOTU2IEMxMi45ODM1MjQ5LDMuNTYwNDM5NTYgMTMuOTMwNjUxMyw0LjA3NDcyNTI3IDEzLjkzMDY1MTMsNS43MzYyNjM3NCBDMTMuOTMwNjUxMyw3LjM5NzgwMjIgMTIuOTgzNTI0OSw3Ljk1MTY0ODM1IDEwLjA2MzIxODQsNy45NTE2NDgzNSBMMy45MDY4OTY1NSw3Ljk1MTY0ODM1IEwzLjkwNjg5NjU1LDMuNTYwNDM5NTYgWiIgaWQ9IlNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTM5LjczOTg0NjcsMTAuMDQ4MzUxNiBDMzkuNzM5ODQ2NywxMi40NjE1Mzg1IDM5LjEwODQyOTEsMTQuOTE0Mjg1NyAzNC4yNTQ0MDYxLDE0LjkxNDI4NTcgQzI5LjQzOTg0NjcsMTQuOTE0Mjg1NyAyOC43Njg5NjU1LDEyLjQ2MTUzODUgMjguNzY4OTY1NSwxMC4wNDgzNTE2IEwyOC43Njg5NjU1LDAuMzk1NjA0Mzk2IEwyNS4wNTkzODcsMC4zOTU2MDQzOTYgTDI1LjA1OTM4NywxMC4yODU3MTQzIEMyNS4wNTkzODcsMTUuNTA3NjkyMyAyOC4xMzc1NDc5LDE4LjE1ODI0MTggMzQuMjE0OTQyNSwxOC4xNTgyNDE4IEM0MC4yOTIzMzcyLDE4LjE1ODI0MTggNDMuMzcwNDk4MSwxNS41MDc2OTIzIDQzLjM3MDQ5ODEsMTAuMjg1NzE0MyBMNDMuMzcwNDk4MSwwLjM5NTYwNDM5NiBMMzkuNjYwOTE5NSwwLjM5NTYwNDM5NiBMMzkuNjYwOTE5NSwxMC4wNDgzNTE2IEwzOS43Mzk4NDY3LDEwLjA0ODM1MTYgWiIgaWQ9IlNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTY3LjE2NzA0OTgsOC40NjU5MzQwNyBDNjguMDc0NzEyNiw3LjgzMjk2NzAzIDY4LjkwMzQ0ODMsNi45NjI2MzczNiA2OC45MDM0NDgzLDQuOTg0NjE1MzggQzY4LjkwMzQ0ODMsMS45Mzg0NjE1NCA2Ni42NTQwMjMsMC40MzUxNjQ4MzUgNjIuMDc2MjQ1MiwwLjQzNTE2NDgzNSBMNTEuNjk3MzE4LDAuNDM1MTY0ODM1IEw1MS42OTczMTgsMTcuNzYyNjM3NCBMNjIuNzA3NjYyOCwxNy43NjI2Mzc0IEM2Ny4wNDg2NTksMTcuNzYyNjM3NCA2OS41NzQzMjk1LDE1LjkwMzI5NjcgNjkuNTc0MzI5NSwxMi42NTkzNDA3IEM2OS41NzQzMjk1LDEwLjY0MTc1ODIgNjguMzkwNDIxNSw5LjEzODQ2MTU0IDY3LjE2NzA0OTgsOC40NjU5MzQwNyBaIE02Mi4zMTMwMjY4LDcuMTIwODc5MTIgTDU1LjQwNjg5NjYsNy4xMjA4NzkxMiBMNTUuNDA2ODk2NiwzLjU2MDQzOTU2IEw2Mi4zMTMwMjY4LDMuNTYwNDM5NTYgQzY0LjcyMDMwNjUsMy41NjA0Mzk1NiA2NS4yMzMzMzMzLDQuMjcyNTI3NDcgNjUuMjMzMzMzMyw1LjM0MDY1OTM0IEM2NS4xOTM4Njk3LDYuNDA4NzkxMjEgNjQuNzIwMzA2NSw3LjEyMDg3OTEyIDYyLjMxMzAyNjgsNy4xMjA4NzkxMiBaIE01NS40MDY4OTY2LDEwLjI0NjE1MzggTDYyLjM5MTk1NCwxMC4yNDYxNTM4IEM2NC43OTkyMzM3LDEwLjI0NjE1MzggNjUuODY0NzUxLDEwLjkxODY4MTMgNjUuODY0NzUxLDEyLjM4MjQxNzYgQzY1Ljg2NDc1MSwxMy45NjQ4MzUyIDY0Ljg3ODE2MDksMTQuNTk3ODAyMiA2Mi4zOTE5NTQsMTQuNTk3ODAyMiBMNTUuNDA2ODk2NiwxNC41OTc4MDIyIEw1NS40MDY4OTY2LDEwLjI0NjE1MzggWiIgaWQ9IlNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlJlY3RhbmdsZS1wYXRoIiBwb2ludHM9Ijc2LjgzNTYzMjIgMC40MzUxNjQ4MzUgODAuNTQ1MjEwNyAwLjQzNTE2NDgzNSA4MC41NDUyMTA3IDE3Ljc2MjYzNzQgNzYuODM1NjMyMiAxNy43NjI2Mzc0Ij48L3BvbHlnb24+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTEwMy4wMzk0NjQsMTEuNDcyNTI3NSBDMTAyLjcyMzc1NSwxMi42NTkzNDA3IDEwMS4xODQ2NzQsMTQuOTE0Mjg1NyA5Ny4zNTY3MDUsMTQuOTE0Mjg1NyBDOTMuNTY4MTk5MiwxNC45MTQyODU3IDkxLjEyMTQ1NTksMTIuNjU5MzQwNyA5MS4xMjE0NTU5LDkuMTc4MDIxOTggQzkxLjEyMTQ1NTksNS4zNDA2NTkzNCA5My40MTAzNDQ4LDMuMjQzOTU2MDQgOTcuNTU0MDIzLDMuMjQzOTU2MDQgQzEwMS4xMDU3NDcsMy4yNDM5NTYwNCAxMDIuNTY1OSw1LjMwMTA5ODkgMTAyLjgwMjY4Miw2LjA5MjMwNzY5IEwxMDIuODQyMTQ2LDYuMjUwNTQ5NDUgTDEwNi41NTE3MjQsNi4yNTA1NDk0NSBMMTA2LjQ3Mjc5Nyw1Ljg5NDUwNTQ5IEMxMDUuMTMxMDM0LDEuMDI4NTcxNDMgMTAwLjc5MDAzOCwtMi44NDIxNzA5NGUtMTQgOTcuMzk2MTY4NiwtMi44NDIxNzA5NGUtMTQgQzkxLjEyMTQ1NTksLTIuODQyMTcwOTRlLTE0IDg3LjM3MjQxMzgsMy4yODM1MTY0OCA4Ny4zNzI0MTM4LDguODIxOTc4MDIgQzg3LjM3MjQxMzgsMTQuNTk3ODAyMiA5MS4xMjE0NTU5LDE4LjE5NzgwMjIgOTcuMTE5OTIzNCwxOC4xOTc4MDIyIEMxMDAuMjc3MDExLDE4LjE5NzgwMjIgMTA1Ljc2MjQ1MiwxNy4zMjc0NzI1IDEwNi43NDkwNDIsMTEuNTkxMjA4OCBMMTA2Ljc4ODUwNiwxMS4zNTM4NDYyIEwxMDMuMDc4OTI3LDExLjM1Mzg0NjIgTDEwMy4wMzk0NjQsMTEuNDcyNTI3NSBaIiBpZD0iU2hhcGUiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTIzLjA4Njk3MywwIEMxMTYuNjU0NDA2LDAgMTEyLjgyNjQzNywzLjQ0MTc1ODI0IDExMi44MjY0MzcsOS4yMTc1ODI0MiBDMTEyLjgyNjQzNywxMC43MjA4NzkxIDExMy4zMzk0NjQsMTguMTk3ODAyMiAxMjMuMDg2OTczLDE4LjE5NzgwMjIgQzEzMi44MzQ0ODMsMTguMTk3ODAyMiAxMzMuMzQ3NTEsMTAuNzIwODc5MSAxMzMuMzQ3NTEsOS4yMTc1ODI0MiBDMTMzLjM0NzUxLDMuNDQxNzU4MjQgMTI5LjUxOTU0LDAgMTIzLjA4Njk3MywwIFogTTEyOS42Mzc5MzEsOS4wMTk3ODAyMiBDMTI5LjYzNzkzMSwxNC4zNjA0Mzk2IDEyNS4wNjAxNTMsMTQuOTE0Mjg1NyAxMjMuMDg2OTczLDE0LjkxNDI4NTcgQzEyMS4xMTM3OTMsMTQuOTE0Mjg1NyAxMTYuNTM2MDE1LDE0LjMyMDg3OTEgMTE2LjUzNjAxNSw5LjAxOTc4MDIyIEMxMTYuNTM2MDE1LDUuMzgwMjE5NzggMTE4Ljk4Mjc1OSwzLjI0Mzk1NjA0IDEyMy4wODY5NzMsMy4yNDM5NTYwNCBDMTI3LjE5MTE4OCwzLjI0Mzk1NjA0IDEyOS42Mzc5MzEsNS40MTk3ODAyMiAxMjkuNjM3OTMxLDkuMDE5NzgwMjIgWiIgaWQ9IlNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlNoYXBlIiBwb2ludHM9IjE1NC44OTQ2MzYgMC40MzUxNjQ4MzUgMTU0Ljg5NDYzNiAxMi4zNDI4NTcxIDE0My44ODQyOTEgMC40MzUxNjQ4MzUgMTQwLjA5NTc4NSAwLjQzNTE2NDgzNSAxNDAuMDk1Nzg1IDE3Ljc2MjYzNzQgMTQzLjY0NzUxIDE3Ljc2MjYzNzQgMTQzLjY0NzUxIDUuMzgwMjE5NzggMTU1LjEzMTQxOCAxNy43NjI2Mzc0IDE1OC40NDYzNiAxNy43NjI2Mzc0IDE1OC40NDYzNiAwLjQzNTE2NDgzNSI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwIiBmaWxsPSIjMDBBNjlBIiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0zOC4wMDM0NDgzLDI0LjQ4NzkxMjEgQzM3LjQxMTQ5NDMsMjIuMTkzNDA2NiAzNS45MTE4Nzc0LDIwLjI5NDUwNTUgMzMuODk5MjMzNywxOS4xMDc2OTIzIEwyMy4wODYyMDY5LDEyLjgxNzU4MjQgTDIyLjA2MDE1MzMsMTIuMjI0MTc1OCBMMjIuMDYwMTUzMywxMi4yMjQxNzU4IEwxOS44NTAxOTE2LDEwLjk1ODI0MTggTDE5Ljg1MDE5MTYsMTcuOTYwNDM5NiBMMzAuOSwyNC4zNjkyMzA4IEMzMS41MzE0MTc2LDI0LjcyNTI3NDcgMzIuMDA0OTgwOCwyNS4zNTgyNDE4IDMyLjIwMjI5ODksMjYuMDcwMzI5NyBDMzIuMzk5NjE2OSwyNi43ODI0MTc2IDMyLjI4MTIyNjEsMjcuNTM0MDY1OSAzMS45MjYwNTM2LDI4LjIwNjU5MzQgQzMxLjU3MDg4MTIsMjguODM5NTYwNCAzMC45Mzk0NjM2LDI5LjMxNDI4NTcgMzAuMjI5MTE4OCwyOS41MTIwODc5IEMyOS43NTU1NTU2LDI5LjYzMDc2OTIgMjkuMjAzMDY1MSwyOS42MzA3NjkyIDI4LjcyOTUwMTksMjkuNTEyMDg3OSBMMjguNDUzMjU2NywyOS40MzI5NjcgTDIyLjQxNTMyNTcsMzIuOTUzODQ2MiBMMjUuMDk4ODUwNiwzNC40OTY3MDMzIEMyNi40NDA2MTMsMzUuMjg3OTEyMSAyNy45Nzk2OTM1LDM1LjY4MzUxNjUgMjkuNTE4NzczOSwzNS42ODM1MTY1IEwyOS41MTg3NzM5LDM1LjY4MzUxNjUgQzMwLjMwODA0NiwzNS42ODM1MTY1IDMxLjA1Nzg1NDQsMzUuNTY0ODM1MiAzMS44MDc2NjI4LDM1LjM2NzAzMyBDMzQuMDk2NTUxNywzNC43NzM2MjY0IDM1Ljk5MDgwNDYsMzMuMjcwMzI5NyAzNy4xNzQ3MTI2LDMxLjI1Mjc0NzMgQzM4LjMxOTE1NzEsMjkuMTU2MDQ0IDM4LjYzNDg2NTksMjYuNzQyODU3MSAzOC4wMDM0NDgzLDI0LjQ4NzkxMjEgWiIgaWQ9IlNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTE2LjQ1NjMyMTgsMjEuNjc5MTIwOSBMMTYuNDU2MzIxOCw4Ljg2MTUzODQ2IEMxNi40NTYzMjE4LDcuMzE4NjgxMzIgMTcuNzE5MTU3MSw2LjA1Mjc0NzI1IDE5LjI1ODIzNzUsNi4wNTI3NDcyNSBDMjAuNTIxMDcyOCw2LjA1Mjc0NzI1IDIxLjYyNjA1MzYsNi45MjMwNzY5MiAyMS45NDE3NjI1LDguMTA5ODkwMTEgTDIyLjAyMDY4OTcsOC4zODY4MTMxOSBMMjguMDk4MDg0MywxMS45MDc2OTIzIEwyOC4wOTgwODQzLDguODYxNTM4NDYgQzI4LjA5ODA4NDMsMy45OTU2MDQ0IDI0LjE1MTcyNDEsMCAxOS4yNTgyMzc1LDAgQzE0LjM2NDc1MSwwIDEwLjQxODM5MDgsMy45NTYwNDM5NiAxMC40MTgzOTA4LDguODYxNTM4NDYgTDEwLjQxODM5MDgsMjUuMTYwNDM5NiBMMTYuNDU2MzIxOCwyMS42NzkxMjA5IFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yMS40Mjg3MzU2LDIyLjY2ODEzMTkgTDEwLjI2MDUzNjQsMjkuMTE2NDgzNSBDOS44MjY0MzY3OCwyOS4zNTM4NDYyIDkuMzUyODczNTYsMjkuNDcyNTI3NSA4Ljg3OTMxMDM0LDI5LjQ3MjUyNzUgQzcuODkyNzIwMzEsMjkuNDcyNTI3NSA2Ljk0NTU5Mzg3LDI4LjkxODY4MTMgNi40NzIwMzA2NSwyOC4wODc5MTIxIEM2LjExNjg1ODI0LDI3LjQ1NDk0NTEgNS45OTg0Njc0MywyNi43MDMyOTY3IDYuMTk1Nzg1NDQsMjUuOTUxNjQ4NCBDNi4zMTQxNzYyNSwyNS40NzY5MjMxIDYuNTkwNDIxNDYsMjUuMDAyMTk3OCA2Ljk0NTU5Mzg3LDI0LjY0NjE1MzggTDcuMTQyOTExODgsMjQuNDQ4MzUxNiBMNy4xNDI5MTE4OCwxNy40NDYxNTM4IEw0LjQ1OTM4Njk3LDE4Ljk4OTAxMSBDMi40MDcyNzk2OSwyMC4xNzU4MjQyIDAuOTQ3MTI2NDM3LDIyLjA3NDcyNTMgMC4zNTUxNzI0MTQsMjQuMzY5MjMwOCBDLTAuMjM2NzgxNjA5LDI2LjY2MzczNjMgMC4wMzk0NjM2MDE1LDI5LjAzNzM2MjYgMS4yMjMzNzE2NSwzMS4wOTQ1MDU1IEMyLjgwMTkxNTcxLDMzLjgyNDE3NTggNS43MjIyMjIyMiwzNS41MjUyNzQ3IDguODc5MzEwMzQsMzUuNTI1Mjc0NyBDMTAuNDE4MzkwOCwzNS41MjUyNzQ3IDExLjk1NzQ3MTMsMzUuMTI5NjcwMyAxMy4yOTkyMzM3LDM0LjMzODQ2MTUgTDI3LjQ2NjY2NjcsMjYuMTQ5NDUwNSBMMjEuNDI4NzM1NiwyMi42NjgxMzE5IFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPHRleHQgaWQ9IlBBUlRORVIiIGZvbnQtZmFtaWx5PSJSb2JvdG8tTWVkaXVtLCBSb2JvdG8iIGZvbnQtc2l6ZT0iMTMiIGZvbnQtd2VpZ2h0PSI0MDAiIGxldHRlci1zcGFjaW5nPSIyIiBmaWxsPSIjRkZGRkZGIj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8dHNwYW4geD0iMTM3Ljc5MTUwNCIgeT0iNDMiPlBBUlRORTwvdHNwYW4+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHRzcGFuIHg9IjE5Ny44ODc2OTUiIHk9IjQzIj5SPC90c3Bhbj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvdGV4dD4KICAgICAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  ${media.tablet`
    background-size: cover;
    background-position: 0;
    width: 38px;
    height: 37px;
  `}
`;

export const DesktopNavBarItem = styled(NavLink)`
  position: relative;
  display: flex;
  align-items: center;
  justify-self: flex-end;
  height: 100%;
  margin-right: 60px;
  border-bottom: 4px solid transparent;
  text-transform: uppercase;
  font-weight: ${props => props.theme.fontWeightMedium};
  font-size: 15px;
  color: ${transparentize(0.2, '#fff')};

  &:last-child {
    margin-right: 0;
  }

  &.active {
    border-bottom-color: ${props => props.theme.brandPrimary};

    ${NavigationBarIcon} {
      color: ${props => props.theme.brandPrimary};
    }
  }

  ${media.desktop`
    font-size: 14px;
    margin-right: 40px;

    ${NavigationBarIcon} {
      width: 25px;
      height: 25px;
    }
  `}

  ${media.tablet`
    ${NavigationBarIcon} {
      display: none;
    }
  `}
`;

export const DesktopNavBarButton = styled.div`
  ${BareButtonStyle};
  position: relative;
  display: flex;
  align-items: center;
  justify-self: flex-end;
  height: 100%;
  margin-left: 45px;
  border-bottom: 4px solid transparent;
  text-transform: uppercase;
  font-weight: ${props => props.theme.fontWeightMedium};
  font-size: 15px;
  color: ${transparentize(0.2, '#fff')};

  ${props =>
    props.isHighlighted &&
    css`
      ${NavigationBarIcon} {
        color: ${props => props.theme.brandPrimary};
      }
    `};

  ${media.desktop`
    font-size: 14px;
    margin-left: 25px;

    ${NavigationBarIcon} {
      width: 25px;
      height: 25px;
    }
  `}

  ${media.tablet`
    font-size: 13px;
    margin-left: 10px;

    ${NavigationBarIcon} {
      display: none;
    }
  `}
`;

const NavBarMenuItemStyle = props => css`
  display: block;
  padding: 8px 20px;
  text-transform: none;
  background-color: #fff;
  color: ${props.theme.brandDefault};

  &:hover {
    background-color: ${props.theme.brandPrimary};
    color: #fff;
  }

  ${media.desktop`
    padding: 12px 20px;
  `}

  ${media.tablet`
    padding: 20px 15px;
  `}
`;

export const DesktopNavBarMenuItem = styled(Link)`
  ${NavBarMenuItemStyle}
`;

export const DesktopNavBarMenuButton = styled.div`
  ${NavBarMenuItemStyle}
`;

export const DesktopNavBarMenu = styled.div`
  position: fixed;
  top: 60px;
  right: 10px;
  display: none;
  width: 220px;
  background-color: #fff;
  border: 1px solid ${transparentize(0.96, '#000')};
  box-shadow: 0 2px 4px ${transparentize(0.9, '#000')};

  ${props =>
    props.isOpen &&
    css`
      display: block;
      animation: ${fadeAndSlideInDown} 0.1s ease-out;
    `};

  ${media.desktop`
    width: 200px;
  `}

  ${media.tablet`
    width: 150px;
  `}
`;

export const DesktopNavBarItemsContainer = styled.div`
  display: flex;
  height: 70px;
`;

export const DesktopNavBarContainer = styled.div`
  position: relative;
  z-index: 1;
  padding: 0px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => props.theme.brandDefault};
  box-shadow: 0 2px 4px ${props => transparentize(0.9, props.theme.grayBase)};
`;
